function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* global React, window, PRODUCTS, COLLECTIONS */
/* global Button, Pill, Eyebrow, Icon, SectionHead, ProductCard, swatch */
// ============================================================================
// Collection page — small hero, sticky filter rail, gallery grid
// ============================================================================
var _React = React,
  useStateC = _React.useState,
  useMemoC = _React.useMemo;
function CollectionPage(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? "best-sellers" : _ref$id,
    onCard = _ref.onCard,
    onAdd = _ref.onAdd,
    onBack = _ref.onBack;
  var collection = COLLECTIONS.find(function (c) {
    return c.id === id;
  }) || COLLECTIONS[0];
  var _useStateC = useStateC("All"),
    _useStateC2 = _slicedToArray(_useStateC, 2),
    type = _useStateC2[0],
    setType = _useStateC2[1];
  var _useStateC3 = useStateC("All"),
    _useStateC4 = _slicedToArray(_useStateC3, 2),
    cause = _useStateC4[0],
    setCause = _useStateC4[1];
  var _useStateC5 = useStateC("All"),
    _useStateC6 = _slicedToArray(_useStateC5, 2),
    size = _useStateC6[0],
    setSize = _useStateC6[1];
  var _useStateC7 = useStateC("Featured"),
    _useStateC8 = _slicedToArray(_useStateC7, 2),
    sort = _useStateC8[0],
    setSort = _useStateC8[1];
  var _useStateC9 = useStateC("grid"),
    _useStateC0 = _slicedToArray(_useStateC9, 2),
    view = _useStateC0[0],
    setView = _useStateC0[1];
  var TYPES = useMemoC(function () {
    return ["All"].concat(_toConsumableArray(new Set(PRODUCTS.map(function (p) {
      return p.type;
    }))));
  }, []);
  var CAUSES = ["All", "Feminist", "Protest", "Mental Health", "Immigration", "Brand"];
  var SIZES = ["All", "XS", "S", "M", "L", "XL", "2XL", "3XL", "One Size"];
  var SORTS = ["Featured", "Newest", "Price ↑", "Price ↓", "Bestsellers"];
  var products = PRODUCTS;
  // Collection-based filtering (id comes from nav/openCollection)
  var SHOW_ALL_COLLS = ["best-sellers", "new-arrivals", ""];
  if (id && SHOW_ALL_COLLS.indexOf(id) === -1) {
    products = products.filter(function (p) {
      return p.collection === id ||
        (id === "hoodies" && (p.type || "").toLowerCase().indexOf("hoodie") !== -1) ||
        (id === "womens-tees" && (p.type || "").toLowerCase().indexOf("women") !== -1) ||
        (id === "unisex-tees" && (p.type || "").toLowerCase().indexOf("unisex") !== -1) ||
        (id === "accessories" && ["hat","accessories","mug","bag"].indexOf((p.type || "").toLowerCase()) !== -1) ||
        (id === "feminist" && p.cause === "Feminist") ||
        (id === "protest" && p.cause === "Protest") ||
        (id === "lgbtq-pride" && p.cause === "LGBTQ+") ||
        (id === "funny-and-political" && p.cause === "Humor");
    });
  }
  if (type !== "All") products = products.filter(function (p) {
    return p.type === type;
  });
  if (cause !== "All") products = products.filter(function (p) {
    return p.cause === cause;
  });
  if (size !== "All") products = products.filter(function (p) {
    return (p.sizes || []).includes(size);
  });
  if (sort === "Price ↑") products = _toConsumableArray(products).sort(function (a, b) {
    return a.price - b.price;
  });
  if (sort === "Price ↓") products = _toConsumableArray(products).sort(function (a, b) {
    return b.price - a.price;
  });
  if (sort === "Bestsellers") products = _toConsumableArray(products).sort(function (a, b) {
    return (b.badge === "BESTSELLER") - (a.badge === "BESTSELLER");
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    style: {
      background: "var(--bone)",
      borderBottom: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      padding: "48px 32px 64px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-sans)",
      fontSize: 12,
      color: "var(--muted)",
      letterSpacing: "0.04em",
      marginBottom: 24
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      onBack();
    },
    style: {
      color: "inherit"
    }
  }, "Home"), /*#__PURE__*/React.createElement("span", {
    style: {
      margin: "0 8px"
    }
  }, "/"), /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      onBack();
    },
    style: {
      color: "inherit"
    }
  }, "Shop"), /*#__PURE__*/React.createElement("span", {
    style: {
      margin: "0 8px"
    }
  }, "/"), /*#__PURE__*/React.createElement("span", {
    style: {
      color: "var(--ink)"
    }
  }, collection.name)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1.4fr 1fr",
      gap: 64,
      alignItems: "flex-end"
    },
    className: "responsive-2col"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Eyebrow, {
    tone: "rust"
  }, products.length, " pieces \xB7 in this edit"), /*#__PURE__*/React.createElement("h1", {
    style: {
      marginTop: 20,
      fontFamily: "var(--font-serif)",
      fontWeight: 400,
      fontSize: "clamp(48px, 7vw, 112px)",
      lineHeight: 0.98,
      letterSpacing: "-0.02em",
      color: "var(--ink)"
    }
  }, collection.name, /*#__PURE__*/React.createElement("span", {
    style: {
      color: "var(--rust)"
    }
  }, "."))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-serif)",
      fontStyle: "italic",
      fontSize: 22,
      lineHeight: 1.5,
      color: "var(--muted)",
      margin: 0
    }
  }, "Every piece in this collection funds organizations on the front lines. Your purchase is the receipt."))))), /*#__PURE__*/React.createElement("section", {
    className: "section--sm",
    style: {
      paddingTop: 40
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "240px 1fr",
      gap: 56
    },
    className: "responsive-coll"
  }, /*#__PURE__*/React.createElement("aside", {
    style: {
      position: "sticky",
      top: 96,
      alignSelf: "flex-start"
    },
    className: "responsive-aside"
  }, /*#__PURE__*/React.createElement(FilterGroup, {
    label: "Type",
    options: TYPES,
    value: type,
    onChange: setType
  }), /*#__PURE__*/React.createElement(FilterGroup, {
    label: "Cause",
    options: CAUSES,
    value: cause,
    onChange: setCause
  }), /*#__PURE__*/React.createElement(FilterGroup, {
    label: "Size",
    options: SIZES,
    value: size,
    onChange: setSize
  }), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setType("All");
      setCause("All");
      setSize("All");
    },
    style: {
      background: "transparent",
      border: "none",
      padding: 0,
      marginTop: 8,
      fontFamily: "var(--font-sans)",
      fontSize: 12,
      color: "var(--rust)",
      cursor: "pointer",
      borderBottom: "1px solid var(--rust)",
      paddingBottom: 2
    }
  }, "Reset filters \u21BA")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "14px 0 22px",
      borderBottom: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-sans)",
      fontSize: 13,
      color: "var(--muted)"
    }
  }, "Showing ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: "var(--ink)",
      fontWeight: 500
    }
  }, products.length), " of ", PRODUCTS.length), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      border: "1px solid var(--line-2)"
    }
  }, [{
    k: "grid",
    ic: "grid"
  }, {
    k: "list",
    ic: "list"
  }].map(function (v) {
    return /*#__PURE__*/React.createElement("button", {
      key: v.k,
      onClick: function onClick() {
        return setView(v.k);
      },
      style: {
        background: view === v.k ? "var(--ink)" : "transparent",
        color: view === v.k ? "var(--bone)" : "var(--ink)",
        border: "none",
        padding: 8,
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: v.ic,
      size: 16
    }));
  })), /*#__PURE__*/React.createElement("label", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      fontSize: 12,
      color: "var(--muted)"
    }
  }, /*#__PURE__*/React.createElement("span", null, "Sort"), /*#__PURE__*/React.createElement("select", {
    value: sort,
    onChange: function onChange(e) {
      return setSort(e.target.value);
    },
    style: {
      border: "none",
      borderBottom: "1px solid var(--ink)",
      background: "transparent",
      padding: "4px 8px 4px 0",
      fontFamily: "var(--font-sans)",
      fontSize: 13,
      color: "var(--ink)",
      cursor: "pointer"
    }
  }, SORTS.map(function (s) {
    return /*#__PURE__*/React.createElement("option", {
      key: s
    }, s);
  }))))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 32,
      display: "grid",
      gridTemplateColumns: view === "list" ? "1fr" : "repeat(3, 1fr)",
      gap: 32
    },
    className: view === "grid" ? "responsive-3col" : ""
  }, products.length === 0 ? /*#__PURE__*/React.createElement("div", {
    style: {
      gridColumn: "1 / -1",
      padding: "80px 32px",
      textAlign: "center",
      border: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: "var(--font-serif)",
      fontSize: 36,
      margin: 0,
      color: "var(--ink)"
    }
  }, "No matches yet."), /*#__PURE__*/React.createElement("p", {
    style: {
      color: "var(--muted)"
    }
  }, "Reset filters to see all ", PRODUCTS.length, " pieces.")) : view === "list" ? products.map(function (p) {
    return /*#__PURE__*/React.createElement(ProductListRow, {
      key: p.id,
      p: p,
      onCard: onCard,
      onAdd: onAdd
    });
  }) : products.map(function (p) {
    return /*#__PURE__*/React.createElement(ProductCard, {
      key: p.id,
      p: p,
      onCard: onCard,
      onAdd: onAdd
    });
  })))))), /*#__PURE__*/React.createElement("style", null, "\n        @media (max-width: 1024px) {\n          .responsive-coll { grid-template-columns: 1fr !important; gap: 32px !important; }\n          .responsive-aside { position: static !important; }\n        }\n      "));
}

// Filter group ---------------------------------------------------------------
function FilterGroup(_ref2) {
  var label = _ref2.label,
    options = _ref2.options,
    value = _ref2.value,
    onChange = _ref2.onChange;
  var _useStateC1 = useStateC(true),
    _useStateC10 = _slicedToArray(_useStateC1, 2),
    open = _useStateC10[0],
    setOpen = _useStateC10[1];
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 28,
      paddingBottom: 24,
      borderBottom: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setOpen(!open);
    },
    style: {
      background: "transparent",
      border: "none",
      padding: 0,
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 12,
      letterSpacing: "0.16em",
      textTransform: "uppercase",
      color: "var(--ink)"
    }
  }, /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement(Icon, {
    name: "arrowDown",
    size: 12,
    style: {
      transform: open ? "rotate(0)" : "rotate(-90deg)",
      transition: "transform 160ms"
    }
  })), open && /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: "none",
      padding: 0,
      margin: "16px 0 0",
      display: "flex",
      flexDirection: "column",
      gap: 2
    }
  }, options.map(function (o) {
    var active = value === o;
    return /*#__PURE__*/React.createElement("li", {
      key: o
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return onChange(o);
      },
      style: {
        width: "100%",
        textAlign: "left",
        background: "transparent",
        border: "none",
        padding: "6px 0",
        cursor: "pointer",
        fontFamily: "var(--font-sans)",
        fontSize: 14,
        color: active ? "var(--ink)" : "var(--muted)",
        fontWeight: active ? 500 : 400,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      },
      onMouseEnter: function onMouseEnter(e) {
        if (!active) e.currentTarget.style.color = "var(--ink)";
      },
      onMouseLeave: function onMouseLeave(e) {
        if (!active) e.currentTarget.style.color = "var(--muted)";
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "inline-flex",
        alignItems: "center",
        gap: 10
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        width: 12,
        height: 12,
        border: "1px solid " + (active ? "var(--ink)" : "var(--line-2)"),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, active && /*#__PURE__*/React.createElement("span", {
      style: {
        width: 6,
        height: 6,
        background: "var(--ink)"
      }
    })), o)));
  })));
}

// ---- List row variant ------------------------------------------------------
function ProductListRow(_ref3) {
  var p = _ref3.p,
    onCard = _ref3.onCard,
    onAdd = _ref3.onAdd;
  var _useStateC11 = useStateC(false),
    _useStateC12 = _slicedToArray(_useStateC11, 2),
    hover = _useStateC12[0],
    setHover = _useStateC12[1];
  return /*#__PURE__*/React.createElement("article", {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    onClick: function onClick() {
      return onCard(p);
    },
    style: {
      display: "grid",
      gridTemplateColumns: "180px 1fr auto",
      gap: 32,
      padding: "20px 0",
      borderBottom: "1px solid var(--line)",
      cursor: "pointer",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      aspectRatio: "1/1.1",
      overflow: "hidden",
      background: "var(--bone-2)"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: p.img,
    alt: p.name,
    style: {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transition: "opacity 240ms",
      opacity: hover && p.imgAlt ? 0 : 1
    }
  }), p.imgAlt && /*#__PURE__*/React.createElement("img", {
    src: p.imgAlt,
    alt: "",
    style: {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      opacity: hover ? 1 : 0,
      transition: "opacity 240ms"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(Eyebrow, null, p.cause, " \xB7 ", p.type), /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: "10px 0 0",
      fontFamily: "var(--font-serif)",
      fontWeight: 400,
      fontSize: 28,
      lineHeight: 1.15,
      color: "var(--ink)"
    }
  }, p.name), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 8,
      color: "var(--muted)",
      fontSize: 14,
      maxWidth: 540
    }
  }, p.desc), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 10,
      marginTop: 12,
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 5
    }
  }, (p.colors || []).filter(function(c) { return c && c !== 'Default Title'; }).slice(0, 4).map(function (c, i) {
    return /*#__PURE__*/React.createElement("span", {
      key: i,
      style: {
        width: 10,
        height: 10,
        borderRadius: 999,
        background: swatch(c),
        border: "1px solid var(--line-2)"
      }
    });
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-sans)",
      fontSize: 11,
      color: "var(--faint)",
      letterSpacing: "0.08em",
      textTransform: "uppercase"
    }
  }, (function() {
    var cols = (p.colors || []).filter(function(c) { return c && c !== 'Default Title'; });
    var szs = (p.sizes || []).length;
    if (cols.length === 0) return szs + (szs === 1 ? ' size' : ' sizes');
    return cols.length + ' color' + (cols.length === 1 ? '' : 's') + ' \xB7 ' + szs + (szs === 1 ? ' size' : ' sizes');
  }()))))  , /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-serif)",
      fontSize: 28
    }
  }, "$", p.price.toFixed(0)), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    size: "sm",
    onClick: function onClick(e) {
      e.stopPropagation();
      onAdd === null || onAdd === void 0 || onAdd(_objectSpread(_objectSpread({}, p), {}, {
        size: "M",
        color: (p.colors || [""])[0],
        qty: 1
      }));
    }
  }, "Quick add")));
}
Object.assign(window, {
  CollectionPage: CollectionPage
});
